import { motion } from "framer-motion";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { waLink, MESSAGES, IMAGES } from "@/constants/site";

const EASE = [0.22, 1, 0.36, 1];

const PHOTOS = [
  { src: IMAGES.transf1, alt: "Antes e depois: mega hair loiro longo e volumoso" },
  { src: IMAGES.transf2, alt: "Antes e depois: mega hair morena com ondas" },
  { src: IMAGES.transf3, alt: "Antes e depois: mega hair com mechas balayage" },
];

export const Transformacoes = () => (
  <section id="transformacoes" data-testid="transformations-section" className="relative bg-[#0A0A0B] py-24 lg:py-32">
    <div className="pointer-events-none absolute left-0 top-1/3 h-72 w-72 rounded-full bg-[#D4AF37]/5 blur-[120px]" />
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mb-16 max-w-2xl"
      >
        <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-[#F9F8F6]">
          Resultados Reais
        </p>
        <h2 className="font-display text-3xl font-semibold tracking-tight text-[#F9F8F6] sm:text-4xl lg:text-5xl">
          Antes &amp; <span className="italic text-gold-gradient">Depois</span>
        </h2>
        <p className="mt-5 text-base leading-relaxed text-[#A1A09E] sm:text-lg">
          Transformações feitas aqui no Salão Estrela. Mega hair natural e de verdade.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
        {PHOTOS.map((photo, i) => (
          <motion.figure
            key={photo.src}
            data-testid={`transformation-card-${i + 1}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.12 }}
            className="group overflow-hidden rounded-2xl border border-white/5 bg-[#141416] transition-colors duration-500 hover:border-[#D4AF37]/40"
          >
            <img
              src={photo.src}
              alt={photo.alt}
              loading="lazy"
              className="aspect-[9/16] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04]"
            />
          </motion.figure>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: EASE, delay: 0.2 }}
        className="mt-14 text-center"
      >
        <a
          href={waLink(MESSAGES.transformacao)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="transformations-whatsapp-btn"
          className="group inline-flex items-center gap-3 rounded-full border border-[#D4AF37]/40 px-8 py-4 text-xs font-extrabold uppercase tracking-[0.2em] text-[#F9F8F6] transition-all duration-300 hover:border-[#D4AF37] hover:bg-[#0A0A0B] hover:text-[#F9F8F6]"
        >
          <WhatsAppIcon className="h-5 w-5" />
          Quero minha transformação
        </a>
      </motion.div>
    </div>
  </section>
);
